import React, { useState } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

const Counter = () => {
  const [viewPortEntered, setViewPortEntered] = useState(false);

  const counters = [
    {
      countNum: 51,
      countTitle: "Projects Delivered",
      counterPrefix: "+",
    },
    {
      countNum: 61,
      countTitle: "Client Served",
      counterPrefix: "+",
    },
    {
      countNum: 4,
      countTitle: "In House Products",
      counterPrefix: "+",
    },
    {
      countNum: 4,
      countTitle: "Countries Reached",
      counterPrefix: "+",
    },
    {
      countNum: 6,
      countTitle: "Security Audit",
      counterPrefix: "+",
    },
  ];

  return (
    <div id="rs-counter" style={{ padding: '40px 0', overflow: 'hidden' }}>
      <VisibilitySensor
        partialVisibility
        offset={{ bottom: 50 }}
        onChange={(isVisible) => {
          if (isVisible) setViewPortEntered(true);
        }}
      >
        {({ isVisible }) => (
          <div className="stats-row" style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            flexWrap: 'wrap',
            width: '100%',
            padding: '0 20px'
          }}>
            {counters.map((counter, index) => (
              <div
                key={index}
                className="stat-item"
                style={{
                  flex: '1',
                  textAlign: 'center',
                  padding: '20px 10px',
                  position: 'relative',
                  minWidth: '150px',
                  opacity: viewPortEntered ? 1 : 0,
                  transform: viewPortEntered ? 'translateY(0)' : 'translateY(20px)',
                  transition: `opacity 0.6s ease ${index * 0.1}s, transform 0.6s ease ${index * 0.1}s`,
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  const number = e.currentTarget.querySelector('.stat-number');
                  const label = e.currentTarget.querySelector('.stat-label');
                  const plus = e.currentTarget.querySelector('.stat-plus');

                  if (number) {
                    number.style.transform = 'scale(1.1)';
                    number.style.color = '#ffc107';
                    number.style.textShadow = '0 5px 15px rgba(255, 193, 7, 0.2)';
                  }
                  if (label) {
                    label.style.transform = 'translateY(-3px)';
                    label.style.color = '#111827';
                  }
                  if (plus) {
                    plus.style.transform = 'rotate(90deg)';
                  }
                }}
                onMouseLeave={(e) => {
                  const number = e.currentTarget.querySelector('.stat-number');
                  const label = e.currentTarget.querySelector('.stat-label');
                  const plus = e.currentTarget.querySelector('.stat-plus');

                  if (number) {
                    number.style.transform = 'scale(1)';
                    number.style.color = '#111827';
                    number.style.textShadow = 'none';
                  }
                  if (label) {
                    label.style.transform = 'translateY(0)';
                    label.style.color = '#6b7280';
                  }
                  if (plus) {
                    plus.style.transform = 'rotate(0deg)';
                  }
                }}
              >
                {/* Vertical Divider (except for last item) */}
                {index !== counters.length - 1 && (
                  <div className="divider" style={{
                    position: 'absolute',
                    right: 0,
                    top: '25%',
                    height: '50%',
                    width: '1px',
                    background: 'linear-gradient(to bottom, transparent, #e5e7eb, transparent)',
                    transition: 'opacity 0.3s ease'
                  }}></div>
                )}

                {/* Number */}
                <div className="stat-number" style={{
                  fontSize: '42px',
                  fontWeight: 800,
                  color: '#111827',
                  lineHeight: 1,
                  marginBottom: '8px',
                  fontFamily: 'inherit',
                  letterSpacing: '-1px',
                  transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '4px'
                }}>
                  {viewPortEntered && (
                    <CountUp
                      start={0}
                      end={counter.countNum}
                      duration={2.5}
                      useEasing={true}
                    />
                  )}
                  <span
                    className="stat-plus"
                    style={{
                      fontSize: '28px',
                      color: '#ffc107',
                      marginTop: '-6px',
                      transition: 'all 0.4s ease',
                      display: 'inline-block'
                    }}
                  >
                    {counter.counterPrefix}
                  </span>
                </div>

                {/* Label */}
                <div className="stat-label" style={{
                  fontSize: '13px',
                  fontWeight: 600,
                  color: '#6b7280',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  transition: 'all 0.3s ease'
                }}>
                  {counter.countTitle}
                </div>
              </div>
            ))}
          </div>
        )}
      </VisibilitySensor>

      <style>{`
        @media (max-width: 991px) {
          .stats-row {
            justify-content: center !important;
          }
          .stat-item {
            flex: 0 0 50% !important;
            margin-bottom: 20px;
          }
           .stat-item .divider {
            display: none;
           }
        }
        @media (max-width: 576px) {
          .stat-item {
            flex: 0 0 100% !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Counter;
